import { render, staticRenderFns } from "./CodeEdit.vue?vue&type=template&id=27758d7b&scoped=true"
import script from "./CodeEdit.vue?vue&type=script&lang=js"
export * from "./CodeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27758d7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27758d7b')) {
      api.createRecord('27758d7b', component.options)
    } else {
      api.reload('27758d7b', component.options)
    }
    module.hot.accept("./CodeEdit.vue?vue&type=template&id=27758d7b&scoped=true", function () {
      api.rerender('27758d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/CodeEdit.vue"
export default component.exports